import { createTheme } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import shadows from './shadows';

import components from './components';

const theme = createTheme({
  breakpoints,
  components,
  palette,
  shadows,
  shape: {
    borderRadius: 8,
  },
  spacing: 8, // default spacing value
  typography,
});

export default theme;
